import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Href, Primary } from "../../../../Constants/Constants";

const RoundedDemo = () => {
  const [open, setOpen] = useState(false);

  return (
    <ButtonGroup>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="down">
        <DropdownToggle caret color="primary" className="rounded-pill">
          {Primary}
        </DropdownToggle>
        <DropdownMenu className="dropdown-block">
          <DropdownItem href={Href}>{"Dark"}</DropdownItem>
          <DropdownItem href={Href}>{"Light"}</DropdownItem>
          <DropdownItem href={Href}>{"Lighter"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default RoundedDemo;
